import { useCallback, type KeyboardEvent } from 'react'
import { Search, X } from 'lucide-react'

import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
} from '@/components/ui/input-group'

interface ConversationHistorySearchProps {
  value: string
  onChange: (next: string) => void
}

export function ConversationHistorySearch({
  value,
  onChange,
}: ConversationHistorySearchProps) {
  const handleClear = useCallback(() => onChange(''), [onChange])

  const handleKeyDown = useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Escape' && value) {
        e.preventDefault()
        onChange('')
      }
    },
    [value, onChange]
  )

  return (
    <div className="px-3 py-3">
      <InputGroup className="bg-black/5 border-0 shadow-none rounded-xl">
        <InputGroupAddon>
          <Search aria-hidden="true" />
        </InputGroupAddon>
        <InputGroupInput
          type="search"
          placeholder="Search"
          aria-label="Search conversations"
          value={value}
          onChange={(e) => onChange(e.currentTarget.value)}
          onKeyDown={handleKeyDown}
        />
        {value && (
          <InputGroupAddon align="inline-end">
            <InputGroupButton
              type="button"
              size="icon-xs"
              onClick={handleClear}
              aria-label="Clear search">
              <X />
            </InputGroupButton>
          </InputGroupAddon>
        )}
      </InputGroup>
    </div>
  )
}
